import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Droppable } from "react-beautiful-dnd";
import CourseSectionScheduleElementService from "../../../Domain/CourseSectionScheduleElement/CourseSectionScheduleElement.service";
import SchedulerCourseSectionService from "../../../Domain/SchedulerCourseSection/SchedulerCourseSection.service";
import SchedulableService from "../../../Domain/Schedulable/Schedulable.service";
import { AddButton, RemoveButton, } from "../../UI/StandardButtons/StandardButtons";
import DateService from "../../../Services/Shared/Date.service";
import HRWithLabel from "../../UI/HRWithLabel/HRWithLabel";
import SidebarListItem from "./SidebarListItem";
import SchedulerCourseListItem from "./SchedulerCourseListItem";
export const ScheduleCourseSectionDisplay = ({ section, status, onSelect, onSwitch, onRemove, }) => {
    let textClass = "";
    switch (status) {
        case "selected":
            textClass = "text-success";
            break;
        case "conflict":
            textClass = "text-danger";
            break;
        case "courseSelected":
            break;
        case "available":
            break;
        default:
            break;
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "font-weight-bold " + textClass, children: [section.code, " - ", section.section] }), section.instructor && (_jsx("div", { children: _jsx("small", { children: section.instructor.fullName }) })), _jsx("div", { children: _jsxs("small", { children: [DateService.display(section.courseSectionStart), " \u2013", " ", DateService.display(section.courseSectionEnd)] }) }), section.scheduleElements.map((elm, index) => (_jsx("div", { children: _jsxs("div", { className: "border p-2", children: [CourseSectionScheduleElementService.getWeekDisplayString(elm), " ", _jsxs("span", { className: "font-italic", children: [CourseSectionScheduleElementService.getTimeDisplayString(elm.startTimeHours24, elm.startTimeMinutes24), " ", "\u2013", " ", CourseSectionScheduleElementService.getTimeDisplayString(elm.endTimeHours24, elm.endTimeMinutes24)] }), elm.location && elm.location.name && (_jsx("div", { children: _jsxs("small", { className: "text-muted", children: [_jsx("span", { className: "fal fa-map-marker-alt mr-2", "aria-hidden": true }), elm.location && elm.location.name, elm.building && " - " + elm.building.name] }) }))] }) }, index))), _jsxs("div", { className: "mt-3 d-flex w-100 justify-content-end", children: [status === "available" && (_jsx(AddButton, { onClick: onSelect, size: "sm", link: true })), status === "courseSelected" && (_jsxs("button", { className: "btn btn-link btn-sm", onClick: onSwitch, children: [_jsx("span", { className: "fal fa-exchange mr-2", "aria-hidden": true }), "Switch"] })), status === "selected" && (_jsx(RemoveButton, { size: "sm", onClick: onRemove, link: true }))] })] }));
};
const SchedulerCourseList = (props) => {
    const coursesWithSections = React.useMemo(() => (props.courses || []).map((course) => ({
        course,
        sections: (props.sections || []).filter(
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types 'string' and 'number' have no overlap.
        (section) => section.courseId.toString() === course.id),
    })), [props.courses, props.sections]);
    const coursesInList = React.useMemo(() => {
        if (!props.selectedLocations.length) {
            return coursesWithSections;
        }
        return coursesWithSections.map((datum) => {
            const filteredSections = datum.sections.filter((sec) => props.selectedCourseSections.includes(sec.id) ||
                sec.scheduleElements.every((elm) => !elm.location ||
                    !elm.location.id ||
                    props.selectedLocations
                        .map((loc) => loc.id.toString())
                        .includes(elm.location.id.toString())));
            return Object.assign(Object.assign({}, datum), { sections: filteredSections });
        });
    }, [
        coursesWithSections,
        props.selectedCourseSections,
        props.selectedLocations,
    ]);
    // @ts-expect-error - TS2739 - Type '{ course: Course; sections: SchedulerCourseSection[]; }[]' is missing the following properties from type '{ course: Course; sections: SchedulerCourseSection[]; }': course, sections
    const coursesOutsideGroups = React.useMemo(() => coursesInList.filter((cs) => !Object.values(props.groupMap).some((group) => group && group.includes(cs.course.id))), [coursesInList, props.groupMap]);
    const courseSelected = React.useCallback((courseId) => {
        if (!coursesWithSections || !courseId) {
            return false;
        }
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types 'number' and 'string' have no overlap.
        const course = coursesWithSections.find((c) => c.course.id === courseId);
        return course
            ? course.sections.some((s) => props.selectedCourseSections
                // @ts-expect-error - TS2769 - No overload matches this call.
                .concat(props.otherScheduledItems.map((item) => item.id))
                .includes(s.id))
            : false;
    }, [
        coursesWithSections,
        props.otherScheduledItems,
        props.selectedCourseSections,
    ]);
    const groupSelected = React.useCallback((courseId) => {
        // Find the groups this course is in
        const groups = Object.values(props.groupMap).filter((group) => 
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        group.includes(courseId));
        return groups.some((courseIds) => 
        // @ts-expect-error - TS7006 - Parameter 'id' implicitly has an 'any' type.
        courseIds.some((id) => courseSelected(id)));
    }, [courseSelected, props.groupMap]);
    const courseSectionHasConflict = React.useCallback((section) => SchedulableService.hasConflictArray(SchedulerCourseSectionService.getSchedulable(section), props.sections
        .filter((s) => s.courseId !== section.courseId)
        .filter((s) => props.selectedCourseSections.includes(s.id))
        .map(SchedulerCourseSectionService.getSchedulable)
        .concat(props.otherScheduledItems.filter((item) => item.id !== section.id))), [props.otherScheduledItems, props.sections, props.selectedCourseSections]);
    const courseSectionIsSelected = React.useCallback((section) => props.selectedCourseSections.includes(section.id), [props.selectedCourseSections]);
    // TODO this is not reliable
    const courseSectionIsTemporary = React.useCallback((section) => props.otherScheduledItems.map((item) => item.id).includes(section.id), [props.otherScheduledItems]);
    const courseIsTemporary = React.useCallback((courseId) => {
        if (!courseId) {
            return false;
        }
        return props.sections
            .filter((section) => section.courseId.toString() === courseId)
            .some((s) => courseSectionIsTemporary(s));
    }, [courseSectionIsTemporary, props.sections]);
    const isCourseLoaded = (courseId) => props.loadedCourseIds.includes(courseId);
    const isCourseLoading = (courseId) => props.loadingCourseIds.includes(courseId);
    const getCourseListStatus = (courseAndSections) => {
        if (props.selectedCourseSections.some((id) => courseAndSections.sections.some((cs) => cs.id === id))) {
            return "success";
        }
        if (isCourseLoaded(courseAndSections.course) &&
            courseAndSections.sections.every(courseSectionHasConflict)) {
            return "fail";
        }
        return null;
    };
    const getCourseSectionDisplayStatus = React.useCallback((section) => {
        if (courseSectionIsTemporary(section) ||
            courseIsTemporary(section.courseId.toString())) {
            return "temporary";
        }
        if (courseSectionIsSelected(section)) {
            return "selected";
        }
        if (courseSectionHasConflict(section)) {
            return "conflict";
        }
        if (courseSelected(section.courseId.toString())) {
            return "courseSelected";
        }
        if (groupSelected(section.courseId.toString())) {
            return "available";
        }
        return "available";
    }, [
        courseIsTemporary,
        courseSectionHasConflict,
        courseSectionIsSelected,
        courseSectionIsTemporary,
        courseSelected,
        groupSelected,
    ]);
    const selectedCourses = React.useMemo(() => coursesWithSections
        // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
        .filter((cs) => courseSelected(cs.course.id))
        .map((cs) => cs.course), [courseSelected, coursesWithSections]);
    const groupFulfilment = React.useMemo(() => {
        const selectedGroupMap = selectedCourses
            .map((c) => c.id)
            .reduce((sum, cId) => (Object.assign(Object.assign({}, sum), { [cId]: Object.keys(props.groupMap).filter((groupId) => 
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            props.groupMap[groupId].includes(cId)) })), {});
        const getFulfillment = (map) => {
            // Find any course group that just has one match
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            const match = Object.keys(map).find((key) => map[key].length === 1);
            if (match) {
                // Remove this match from all other groups.
                const mapCopy = Object.assign({}, map);
                // @ts-expect-error - TS2542 - Index signature in type '{ readonly [x: string]: string[] | undefined; }' only permits reading.
                delete mapCopy[match];
                const mapWithoutMatch = Object.keys(mapCopy).reduce((sum, key) => (Object.assign(Object.assign({}, sum), { 
                    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
                    [key]: mapCopy[key].filter(
                    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
                    (id) => id.toString() !== map[match].toString()) })), {});
                return Object.assign({ [match]: map[match] }, getFulfillment(mapWithoutMatch));
            }
            return map;
        };
        return getFulfillment(selectedGroupMap);
    }, [props.groupMap, selectedCourses]);
    const isGroupFulfilled = (groupId) => !!Object.values(groupFulfilment).find(
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
    (vals) => vals.includes(groupId) && vals.length === 1);
    const isGroupAmbiguous = (groupId) => {
        if (!isGroupFulfilled(groupId)) {
            return !!Object.values(groupFulfilment).find(
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
            (vals) => vals.includes(groupId) && vals.length > 1);
        }
        return false;
    };
    const getGroupStatus = (groupId) => {
        if (isGroupFulfilled(groupId)) {
            return "success";
        }
        if (isGroupAmbiguous(groupId)) {
            return "question";
        }
        return null;
    };
    return (
    // $FlowFixMe
    _jsx(Droppable, { droppableId: "SchedulerCourseSection", isDropDisabled: true, direction: "vertical", ignoreContainerClipping: true, children: (provided) => (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({}, provided.droppableProps, { ref: provided.innerRef, className: "list-group list-group-flush", children: coursesOutsideGroups &&
                        // @ts-expect-error - TS2339 - Property 'map' does not exist on type '{ course: Course; sections: SchedulerCourseSection[]; }'. | TS7006 - Parameter 'course' implicitly has an 'any' type.
                        coursesOutsideGroups.map((course) => (_jsx(SchedulerCourseListItem, { color: props.getColorOfCourse(course.course.id), course: course.course, sections: course.sections, selectedLocations: props.selectedLocations, getCourseSectionDisplayStatus: getCourseSectionDisplayStatus, onSelectedCourseSectionsChange: props.onSelectedCourseSectionsChange, groupMap: props.groupMap, courseListStatus: getCourseListStatus(course), selectedCourseSections: props.selectedCourseSections, isLoading: isCourseLoading(course.course.id), onToggle: (val) => {
                                if (val && !isCourseLoaded(course.course.id)) {
                                    props.loadCourse(course.course.id);
                                }
                            } }, course.course.id))) })), props.groups.length !== 0 && (_jsxs("div", { children: [_jsx(HRWithLabel, { label: "Groups", className: "px-2 text-muted my-3" }), _jsx("div", { className: "list-group", children: props.groups.map((group) => (_jsx(SidebarListItem, { color: props.getColorOfCourseGroup(group.id), text: group.name, iconStatus: getGroupStatus(group.id), children: _jsx("div", { className: "list-group pl-4", children: coursesInList
                                        .filter((c) => props.groupMap[group.id] &&
                                        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
                                        props.groupMap[group.id].includes(c.course.id))
                                        .map((c) => (_jsx(SchedulerCourseListItem, { course: c.course, sections: c.sections, selectedLocations: props.selectedLocations, getCourseSectionDisplayStatus: getCourseSectionDisplayStatus, onSelectedCourseSectionsChange: props.onSelectedCourseSectionsChange, courseListStatus: getCourseListStatus(c), selectedCourseSections: props.selectedCourseSections, isLoading: isCourseLoading(c.course.id), groupId: group.id, groupMap: props.groupMap, onToggle: (val) => {
                                            if (val && !isCourseLoaded(c.course.id)) {
                                                props.loadCourse(c.course.id);
                                            }
                                        } }, c.course.id))) }) }, group.id))) })] }))] })) }));
};
export default SchedulerCourseList;
